import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AutenticacaoService } from './autenticacao.service';

@Injectable()
export class CredenciaisHttpInterceptor implements HttpInterceptor {

  constructor(
    private autenticacaoService: AutenticacaoService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.autenticacaoService.getToken();

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `${token.token_type} ${token.access_token}`
        }
      });
    }

    return next.handle(req);
  }
}
